import React, {Component} from 'react';
import {connect} from 'react-redux';
import {InputText, Footer} from '../../components';
import {NotificationService, StringService} from '../../services';
import {Messages, RouteKeys} from '../../constants';
import {
  redirectToDataContact,
  redirectToConfirmPhoneSuccess,
} from '../../ducks/Navigate';
import {solicitarCodigoViaSms, validarCodigoViaSms} from '../../ducks/Customer';

import './styles.scss';

class ValidateCodeSms extends Component {
  state = {
    codigo: '',
    currentCount: 45,
    intervalId: '',
  };

  componentDidMount() {
    document.title = StringService.formatTitle(RouteKeys.ValidateCodeSms.title);
    this.resendCode();
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalId);
  }

  timer = () => {
    var newCount = this.state.currentCount - 1;
    if (newCount >= 0) {
      this.setState({currentCount: newCount});
    } else {
      clearInterval(this.state.intervalId);
    }
  };

  resendCode = () => {
    this.props.solicitarCodigoViaSms({
      chave: this.props.chave,
      celular: this.props.celular,
    });

    this.setState({currentCount: 45});
    var intervalId = setInterval(this.timer, 1000);
    this.setState({intervalId: intervalId});
  };
  pressEnter = (event) => {
    if (event.key === 'Enter') {
      this.nextHandle();
    }
  };

  nextHandle = async () => {
    if (this.state.codigo === '') {
      NotificationService.showValidationSingleError(
        Messages.NumberCodeValidationSmsRequired,
      );
      return false;
    }

    let retorno = await this.props.validarCodigoViaSms({
      chave: this.props.chave,
      codigo: this.state.codigo,
    });

    if (!retorno) {
      NotificationService.showValidationSingleError(
        Messages.NumberCodeValidationSmsInvalid,
      );
      return false;
    }

    this.props.redirectToConfirmPhoneSuccess();
  };

  resendCodeHandle = () => {
    this.resendCode();
  };

  goToScreenContact = () => {
    this.props.redirectToDataContact();
  };

  render() {
    return (
      <div className="div-validate-code-sms">
        <div className="content">
          <div className="info">
            <p>
              Para sua segurança, enviamos um código por sms para o celular:
            </p>
            <p>{this.props.celular}</p>
          </div>

          <div className="info-codigo">
            <InputText
              type="tel"
              id="codigo"
              name="codigo"
              maxLength="6"
              placeholder="Digite o código"
              onKeyPress={this.pressEnter}
              onChange={(ev) => {
                let codigo = ev.target.value;
                this.setState({codigo});
              }}
            />
          </div>

          <div className="div-links">
            {this.state.currentCount > 0 && (
              <p>Você pode reenviar o código em {this.state.currentCount}s</p>
            )}
            {this.state.currentCount === 0 && (
              <p>Agora você pode reenviar o código</p>
            )}
            <button className="cursor-pointer" onClick={this.goToScreenContact}>
              Alterar número do celular {'>'}
            </button>
          </div>
        </div>

        <div className="footer-container">
          <Footer
            textNext="Próximo"
            textBack="Reenviar"
            nextHandle={this.nextHandle}
            backHandle={this.resendCodeHandle}
            hideBtnBack={this.state.currentCount > 0}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({customer}) => {
  return {...customer.dadosPessoais, chave: customer.chave};
};

export default connect(mapStateToProps, {
  redirectToDataContact,
  solicitarCodigoViaSms,
  validarCodigoViaSms,
  redirectToConfirmPhoneSuccess,
})(ValidateCodeSms);
